import React, { useContext, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTrashAlt,
  faExternalLink,
  faStickyNote
} from '@fortawesome/pro-regular-svg-icons'
import * as modalActions from 'actions/modalActions'
import {
  openPatient,
  openSkinTest,
  openVialTests,
  isPatientOpen
} from 'Helper/patientHelpers'
import { selectTimerById } from 'selectors/timerSelectors'
import TimerContext from './TimerContext'

const TimerOptions = React.memo(props => {
  const timerContext = useContext(TimerContext)
  const instance = useSelector(state => selectTimerById(state, props.timerId))
  const dispatch = useDispatch()

  const closeModalIfOpen = () => {
    dispatch(modalActions.closeModal('timers'))
  }

  const handleGoToEntityClick = e => {
    dispatch({ type: 'TIMER_OPTIONS_HIDE' })

    const payload = instance.payload

    switch (instance.type) {
      case 'patient':
        openPatient(payload.patient_id)
        break
      case 'skintest':
        openSkinTest(payload.patient_id, payload.skintest_id)
        break
      case 'vialTest':
        openVialTests(payload.patient_id)
        break
    }
    closeModalIfOpen()
  }

  let showGoTo = true
  let disableGoTo = false
  if (
    instance.type === 'skintest' &&
    timerContext.view === 'skinTestTimerTool'
  ) {
    showGoTo = false
  } else if (
    instance.type === 'patient' &&
    timerContext.view === 'patientDetails'
  ) {
    showGoTo = false
  } else if (
    instance.type === 'vialTest' &&
    timerContext.view === 'vialTestTimerTool'
  ) {
    showGoTo = false
  }
  // else if(instance.type == 'patient' && isPatientOpen(instance.payload.patient_id)) {
  //   disableGoTo = true
  // }

  return (
    <div className="timer-timer-options">
      <button
        className="btn btn-danger pflexwin-actionbutton"
        onClick={props.handleDeleteClick}
      >
        <FontAwesomeIcon icon={faTrashAlt} /> Stop
      </button>
      {showGoTo ? (
        <button
          className="btn btn-blue pflexwin-actionbutton"
          onClick={handleGoToEntityClick}
          disabled={disableGoTo}
        >
          <FontAwesomeIcon icon={faExternalLink} /> Go To {instance.type}
        </button>
      ) : null}
    </div>
  )
})

export default TimerOptions
